import { useSelector } from 'react-redux'

import { formatDateLarge, formatDateSmallWithYear } from 'features/billing/helpers'
import { timezoneSelector, dateNotationSelector } from 'selectors/current_user'

export const useDateFormat = (date) => {
  const timezone = useSelector(timezoneSelector)
  const dateNotation = useSelector(dateNotationSelector)

  if (!date) return null
  return formatDateLarge(date, timezone, dateNotation)
}

export const useSmallDateFormat = (date) => {
  const timezone = useSelector(timezoneSelector)
  const dateNotation = useSelector(dateNotationSelector)

  if (!date) return null
  return formatDateSmallWithYear(date, timezone, dateNotation)
}
